<template>
  <div>
    <h1>Editar Usuario</h1>
    <b-card >
      <ValidationObserver ref="form" >
        <b-form @submit.prevent="onSubmit">
          <Loading :active="loading" :is-full-page="true"></Loading>
          <div class="row">
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-name"
                  label-for="name"
                  label="Nombre"
                  class="mb-0"
                >
                  <b-form-input v-model="userE.name" id="name" placeholder="Nombre completo" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Email" rules="required|email" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-email"
                  label-for="email"
                  label="Email"
                  class="mb-0"
                >
                  <b-form-input v-model="userE.email" id="email" placeholder="email@dominio.com" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Role" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-role"
                  label-for="role"
                  label="Role"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-role"
                    class="form-control"
                    v-model="userE.role"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option value="">Role</b-select-option>
                    <b-select-option v-for="p in roles" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-4 col-md-4">
              <ValidationProvider name="Terminal" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-terminal"
                  label-for="terminal"
                  label="terminal"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-terminal"
                    class="form-control"
                    v-model="userE.terminal"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option value="">Terminal</b-select-option>
                    <b-select-option v-for="p in terminals" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <div v-if="errors" class="d-flex">
            <ul style="list-style-type:none;" class="p-0 m-0">
              <template v-for="(field, i) in errors">
                <li v-for="(m, index) in field" :key="i+index" class="text-danger">{{ m }}</li>
              </template>
            </ul>
          </div>
          <b-button @click="onSubmit" class="mt-3"  variant="primary">Guardar</b-button>
        </b-form>
      </ValidationObserver>
    </b-card>
    <h3 class="mt-4">Cambiar password</h3>
    <b-card>
      <ValidationObserver ref="form2" >
        <b-form @submit.prevent="onSubmit2">
          <ValidationProvider name="Password" rules="required" v-slot="{ validated, valid }">
            <b-form-group
              id="input-group-password"
              label-for="password"
              label="Nuevo Password"
              class="mb-0"
            >
              <b-form-input v-model="password" id="password" type="text" placeholder="xxxx" :state="getState(validated, valid)"></b-form-input>
            </b-form-group>
          </ValidationProvider>
          <div v-if="errors" class="d-flex">
            <ul style="list-style-type:none;" class="p-0 m-0">
              <template v-for="(field, i) in errors">
                <li v-for="(m, index) in field" :key="i+index" class="text-danger">{{ m }}</li>
              </template>
            </ul>
          </div>
          <b-button @click="onSubmit2" class="mt-3"  variant="primary">Guardar</b-button>
        </b-form>
      </ValidationObserver>
    </b-card>
    <b-alert v-model="updateSuccess" dismissible variant="success" class="alert-fixed-bottom">
      El usuario se actualizo correctamente
    </b-alert>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'EditUser',
    components:{FontAwesomeIcon, ValidationObserver, ValidationProvider},
    props:{
      user:{
        type:Object,
        required:true
      }
    },
    data() {
      return {
        errors:null,
        errors2:null,
        password:'',
        updateSuccess:false,
        loading:false,
        userE:{
          id:this.user.id,
          name:this.user.name,
          email:this.user.email,
          //password:user.password,
          role:this.user.role,
          terminal:this.user.terminal,
        },
        roles:['admin', 'supervisor', 'cashier', 'seller'],
        terminals:['T2','T3','T4',]
      }
    },
    methods: {
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        this.updateSuccess = false
        this.$refs.form.validate().then((success) => {
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/users/${this.user.id}/update`
            //this.$store.dispatch('quote/setRequest', this.rq)
            this.$axios.post(url, this.userE).then(rs => {
              this.updateSuccess = true
              this.loading = false
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
      },
      onSubmit2(e) {
        e.preventDefault()
        this.errors = null
        this.updateSuccess = false
        this.$refs.form2.validate().then((success) => {
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/users/${this.user.id}/update-password`
            //this.$store.dispatch('quote/setRequest', this.rq)
            this.$axios.post(url, {password:this.password}).then(rs => {
              this.updateSuccess = true
              this.loading = false
              this.password = ''
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
      },
    }
  }
</script>